// extracted by mini-css-extract-plugin
export var expandIcon = "f6_wM";
export var rotated = "f6_wN";